export default "__VITE_ASSET__2e1113c2__"